import { ReactNode, useEffect, useState } from 'react';
import { useRouter } from "next/router";

interface EmptyLayoutProps {
    children: ReactNode;
}

export default function EmptyLayout({ children }: EmptyLayoutProps) {
    const router = useRouter();
    const [loading, setLoading] = useState(true);


    return (
        <div className="min-h-screen">
            {children}
        </div>
    );
}
